import { DateFormatPatterns, DEFAULT_VALUE_IF_NIL } from '@clearverify/constants';
import { formatDate } from '@clearverify/utils';

import { InboxItemRequestItemFragment } from 'src/api';
import { InboxItemStatusChip } from 'src/components/inboxItem';
import { TableColumn } from 'src/components/table';
import { InboxItemTypeWithResources } from 'src/constants/inbox';
import { getVerificationTypeLabel } from 'src/utils/verificationRequest';

export const REQUESTS_COLUMNS_CONSUMER: Array<TableColumn<InboxItemRequestItemFragment>> = [
  {
    title: 'Request Type',
    key: 'type',
    sortable: true,
    nonNullSortable: true,
    render: (_valueByDataPath, inboxItem) => {
      if (inboxItem.type === InboxItemTypeWithResources.VerificationRequest) {
        return `Verification Request (${getVerificationTypeLabel(inboxItem.verificationRequestType)})`;
      }

      return 'Data Dispute';
    },
  },
  {
    title: 'Creation Date',
    key: 'createdAt',
    sortable: true,
    nonNullSortable: true,
    render: (_valueByDataPath, inboxItem) => {
      return formatDate(inboxItem.createdAt, DateFormatPatterns.shortDateWithSlash);
    },
  },
  {
    title: 'Company Name',
    key: 'companyName',
    render: (_valueByDataPath, inboxItem) => {
      return inboxItem.companyName || DEFAULT_VALUE_IF_NIL;
    },
  },
  {
    title: 'Contact Name',
    key: 'contactName',
    render: (_valueByDataPath, inboxItem) => {
      return inboxItem.contactName || DEFAULT_VALUE_IF_NIL;
    },
  },
  {
    title: 'Contact Email',
    key: 'contactEmail',
    render: (_valueByDataPath, inboxItem) => {
      return inboxItem.contactEmail || DEFAULT_VALUE_IF_NIL;
    },
  },
  {
    title: 'Status',
    key: 'status',
    render: (_valueByDataPath, inboxItem) => {
      if (inboxItem.type === InboxItemTypeWithResources.VerificationRequest) {
        return (
          <InboxItemStatusChip status={inboxItem.verificationRequestStatus} isVerificationRequest />
        );
      }

      return (
        <InboxItemStatusChip status={inboxItem.dataDisputeStatus} isVerificationRequest={false} />
      );
    },
  },
];
